import { z } from "zod";

const EnvironmentSchema = z.object({
  dataMode: z.enum(["api", "demo"]).default("demo"),
});

const environment = EnvironmentSchema.parse({
  dataMode: import.meta.env.VITE_DATA_MODE ?? "demo",
});

export const appConfig = {
  ...environment,
  useApi: environment.dataMode === "api",
} as const;
